// Copyright (c) Bentley Systems

/** Tab values for the Projects list, in display order. All but `All` are sent as the `view` query parameter on the OData Projects list endpoint. */
export const PROJECT_LIST_VIEWS = ["All", "Catalog", "Preview", "IntegrationTests"] as const;

export type ProjectListView = (typeof PROJECT_LIST_VIEWS)[number];

export const ProjectListViewLabels: Record<ProjectListView, string> = {
  All: "All",
  Catalog: "Catalog",
  Preview: "In Preview",
  IntegrationTests: "Integration Tests",
};

export const ProjectListViewDescriptions: Record<ProjectListView, string> = {
  All: "All projects, regardless of their stage.",
  Catalog: "Projects not in preview and not part of integration tests.",
  Preview: "Projects currently in preview.",
  IntegrationTests: "Projects that are part of integration tests.",
};